<template>
  <div>
    <div class="row justify-content-center">
      <div class="col">
        <p v-show="fail" @click="GetSchoolCount" style="cursor: pointer;">読み込みに失敗しました<br>クリックして再読み込みする</p>
        <div v-show="!fail" v-for="region in schoolcount" v-bind:key="region.region_id">
          <a
            class="btn btn-link btn-lg area-label"
            data-toggle="collapse"
            aria-expanded="true"
            v-bind:aria-controls="'region'+region.region_id"
            role="button"
            v-bind:href="'#region'+region.region_id"
          >{{ region.region }} Schools</a>
          <div class="collapse show" v-bind:id="'region'+region.region_id">
            <div class="row justify-content-center">
              <div class="col-11">
                <div class="row">
                  <div v-for="school in region.schools" v-bind:key="school.school_id" class="col-4 col-sm-3 col-md-2 col-lg-school-logo" style="margin-bottom:10px;">
                    <content-loader v-show="school.school_name==''"
                      :height="180"
                      :width="110"
                      :speed="2"
                      primaryColor="#f3f3f3"
                      secondaryColor="#ecebeb"
                    >
                      <rect x="5" y="0" rx="0" ry="0" width="100" height="100" />
                      <rect x="7.5" y="110" rx="3" ry="3" width="95" height="10" /> 
                      <rect x="7.5" y="130" rx="3" ry="3" width="95" height="10" /> 
                      <rect x="7.5" y="150" rx="3" ry="3" width="95" height="10" /> 
                      <rect x="40" y="170" rx="3" ry="3" width="30" height="10" /> 
                    </content-loader>
                    
                    <div v-show="school.school_name!=''" class="card cursor" style="border:0px; cursor: pointer;">
                      <router-link class="card-body" style="padding:0px;" :to="{ path:'/database', query:{ sid:school.school_id }}" tag="div">
                        <div style="height:100px; position:relative;">
                          <img v-bind:src="'static/img-fixed/logos/'+school.school_id + '.jpg'" class="card-school-logo" />
                        </div>
                        <span class="text-center d-block card-school-label">{{ school.school_name }}</span>
                        <span class="text-center d-block card-title">({{ school.count }})</span>
                      </router-link>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader"

var dic = [
  { region_id:1,
    region:"US/Canada",
    schools:[
      { school_name:"", count:3, school_id:1 },
      { school_name:"", count:3, school_id:2 },
      { school_name:"", count:3, school_id:3 },
      { school_name:"", count:3, school_id:4 },
      { school_name:"", count:3, school_id:5 },
      { school_name:"", count:3, school_id:6 },
      { school_name:"", count:3, school_id:7 },
    ]
  },
  { region_id:2,
    region:"Europe",
    schools:[]
  },
  { region_id:3,
    region:"Asia",
    schools:[]
  },
  { region_id:4,
    region:"Oceania",
    schools:[]
  },
];



export default {
  name: "Schools",
  components: {
    ContentLoader
  },
  head: {
    meta: [
      { name:"description", content:""}
    ]
  },
  data (){
    return {
      schoolcount:dic,
      fail:false,
    }
  },
  mounted (){
    this.GetSchoolCount();
  },
  methods: {
    GetSchoolCount (){
      this.fail = false;
      this.$axios.get("/api/schoolcount")
      .then(res => { this.schoolcount = res.data })
      .catch((error) => {
        this.fail = true;
      });

    }
  },
  head: {
    meta: [
      { property:"og:url", content:"https://gokakuessay.com" },
    ]
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.btn.btn-link.btn-lg.area-label {
  display: flex;
}

a {
    text-decoration:none!important;
}

a[aria-expanded="false"]:before {
  content: url("data:image/svg+xml;base64,PHN2ZyBkYXRhLWljb249ImNoZXZyb24tZG93biIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDggNTEyIj48cGF0aCBmaWxsPSIjMDA3YmZmIiBkPSJNMjA3LjAyOSAzODEuNDc2TDEyLjY4NiAxODcuMTMyYy05LjM3My05LjM3My05LjM3My0yNC41NjkgMC0zMy45NDFsMjIuNjY3LTIyLjY2N2M5LjM1Ny05LjM1NyAyNC41MjItOS4zNzUgMzMuOTAxLS4wNEwyMjQgMjg0LjUwNWwxNTQuNzQ1LTE1NC4wMjFjOS4zNzktOS4zMzUgMjQuNTQ0LTkuMzE3IDMzLjkwMS4wNGwyMi42NjcgMjIuNjY3YzkuMzczIDkuMzczIDkuMzczIDI0LjU2OSAwIDMzLjk0MUwyNDAuOTcxIDM4MS40NzZjLTkuMzczIDkuMzcyLTI0LjU2OSA5LjM3Mi0zMy45NDIgMHoiPjwvcGF0aD48L3N2Zz4K");
  margin-right: 7px;
  overflow: visible;
  width: 0.875em;
  display: inline-block;
  font-size: inherit;
  height: 1em;
  vertical-align: -0.125em;
}

a[aria-expanded="true"]:before {
  content: url("data:image/svg+xml;base64,PHN2ZyBkYXRhLWljb249ImNoZXZyb24tdXAiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDQ4IDUxMiI+PHBhdGggZmlsbD0iIzAwN2JmZiIgZD0iTTI0MC45NzEgMTMwLjUyNGwxOTQuMzQzIDE5NC4zNDNjOS4zNzMgOS4zNzMgOS4zNzMgMjQuNTY5IDAgMzMuOTQxbC0yMi42NjcgMjIuNjY3Yy05LjM1NyA5LjM1Ny0yNC41MjIgOS4zNzUtMzMuOTAxLjA0TDIyNCAyMjcuNDk1IDY5LjI1NSAzODEuNTE2Yy05LjM3OSA5LjMzNS0yNC41NDQgOS4zMTctMzMuOTAxLS4wNGwtMjIuNjY3LTIyLjY2N2MtOS4zNzMtOS4zNzMtOS4zNzMtMjQuNTY5IDAtMzMuOTQxTDIwNy4wMyAxMzAuNTI1YzkuMzcyLTkuMzczIDI0LjU2OC05LjM3MyAzMy45NDEtLjAwMXoiPjwvcGF0aD48L3N2Zz4=");
  margin-right: 7px;
  overflow: visible;
  width: 0.875em;
  display: inline-block;
  font-size: inherit;
  height: 1em;
  vertical-align: -0.125em;
}


@media (min-width: 992px){
  .col-lg-school-logo {
      -ms-flex: 0 0 14.2857%;
      flex: 0 0 14.2857%;
      max-width: 14.2857%;
  }
}

img.card-school-logo {
    max-width: 100px;
    max-height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

.card-school-label {
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
}
</style>
